export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7490.fa3974d9.jpg";